/* Ibadat theme scripts — no dependencies */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    var fmt = window.themeMoneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  var announce = function (msg) {
    var el = document.getElementById('a11y-status');
    if (el) el.textContent = msg;
  };

  /* ── drawers ─────────────────────────────────────────────────── */
  var openDrawer = function (id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus();
  };
  var closeDrawer = function (d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.drawer.is-open');
      if (open) closeDrawer(open);
    }
  });

  /* ── announcement dismiss ────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.announcement__close');
    if (!btn) return;
    var bar = btn.closest('.announcement');
    bar.remove();
    try { sessionStorage.setItem('ibadat:announcement-closed', '1'); } catch (err) {}
  });
  try {
    if (sessionStorage.getItem('ibadat:announcement-closed')) {
      var bar = document.querySelector('.announcement[data-dismissible="true"]');
      if (bar) bar.remove();
    }
  } catch (err) {}

  /* ── quantity steppers ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap.querySelector('input');
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── cart ────────────────────────────────────────────────────── */
  function refreshCartUI() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js');
      })
      .then(function (r) { return r && r.json(); })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (document.body.getAttribute('data-cart-type') !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var err = form.querySelector('[data-form-error]');
          if (err) { err.textContent = res.description || res.message; err.hidden = false; }
          return;
        }
        refreshCartUI();
        openDrawer('CartDrawer');
        announce('Added to cart');
      })
      .catch(function () {})
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.getAttribute('data-line'), 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), input.value);
  });

  function changeLine(line, quantity) {
    var wrap = document.querySelector('[data-cart-contents]');
    if (wrap) wrap.classList.add('loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function () { refreshCartUI(); })
      .finally(function () { if (wrap) wrap.classList.remove('loading'); });
  }

  /* ── variant picker ──────────────────────────────────────────── */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var form = document.querySelector('form[data-product-form][data-section="' + picker.getAttribute('data-section') + '"]');

      function selected() {
        return Array.prototype.map.call(picker.querySelectorAll('[data-option-index]'), function (group) {
          var active = group.querySelector('[aria-pressed="true"]');
          return active ? active.getAttribute('data-value') : null;
        });
      }

      function update() {
        var chosen = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; });
        });

        picker.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = Number(group.getAttribute('data-option-index'));
          group.querySelectorAll('[data-value]').forEach(function (btn) {
            var probe = chosen.slice();
            probe[idx] = btn.getAttribute('data-value');
            var exists = variants.some(function (v) {
              return v.available && v.options.every(function (o, i) { return probe[i] == null || o === probe[i]; });
            });
            btn.classList.toggle('is-unavailable', !exists);
          });
          var label = group.parentElement.querySelector('[data-option-selected]');
          var active = group.querySelector('[aria-pressed="true"]');
          if (label && active) label.textContent = active.getAttribute('data-value');
        });

        if (!match || !form) return;

        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;

        var priceEl = document.querySelector('[data-price-target][data-section="' + picker.getAttribute('data-section') + '"]');
        if (priceEl) {
          var html = money(match.price);
          if (match.compare_at_price > match.price) {
            html = '<span class="price--sale">' + money(match.price) + '</span><s class="price--compare">' + money(match.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }

        var submit = form.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.getAttribute('data-add-label') : submit.getAttribute('data-soldout-label');
        }

        if (match.featured_media) {
          var thumb = document.querySelector('[data-media-id="' + match.featured_media.id + '"]');
          if (thumb) thumb.click();
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn) return;
        e.preventDefault();
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        update();
      });

      update();
    });
  }

  /* ── product gallery ─────────────────────────────────────────── */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-gallery-main]');
      gal.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-media-id]');
        if (!thumb || !main) return;
        e.preventDefault();
        gal.querySelectorAll('[data-media-id]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        var src = thumb.getAttribute('data-full');
        var img = main.querySelector('img');
        if (img && src) { img.src = src; img.srcset = ''; }
      });
    });
  }

  /* ── predictive search ───────────────────────────────────────── */
  function initSearch() {
    var input = document.querySelector('[data-predictive-input]');
    var results = document.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ── facets: auto-submit ─────────────────────────────────────── */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-facet-form]');
    if (!form) return;
    form.submit();
  });

  function boot() {
    initVariantPickers();
    initGalleries();
    initSearch();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
